import * as React from "react"
import {Box} from "@mui/material"
import {AutocompleteAsyncSeeker, FlagsIconSeeker} from "@ui-seeker/core"

import {createBatchFormData} from "../../@signals"


export default function MarketAutocomplete({...props}) {
	return <AutocompleteAsyncSeeker
		multiple
		urlAjax="/api/products-review/markets"
		label="Markets"
		placeholder="Select Markets..."
		value={createBatchFormData.value.markets}
		onChange={e => {
			createBatchFormData.value = {
				...createBatchFormData.value,
				markets: e.target.value,
				// Clear sites when markets are selected
				sites: e.target.value?.length > 0 ? [] : createBatchFormData.value.sites
			}
		}}
		formatOptionLabel={(option) => (
			<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
				<FlagsIconSeeker countryName={option.value} />
				<span>{option.label}</span>
			</Box>
		)}
		queryParam="search"
		{...props}
	/>
}
